"use strict";

const Comments = {
  /**
   * 最初に表示しておくコメント数
   */
  commentListLiShowLength: 3,
  /**
   * ページロード時に発火する処理をまとめる
   */
  onLoadedFunctions() {
    this.commentsWithAccordion();
    this.displayAllCommentsButton();
    this.hideOverComment();
  },
  /**
   * 読み込み時に吹き出しの高さを計測。4行以上の高さだったら.is_accordionを付ける。「続きを読む」「閉じる」の対応の為。
   */
  commentsWithAccordion() {
    const commentTexts = document.querySelectorAll(".comment_box .commentText");
    commentTexts.forEach((commentText) => {
      const height = commentText.clientHeight;
      const comment = commentText.parentNode;
      if (height >= 120) {
        comment.classList.add("is_accordion");
      }
    });
  },
  /**
   * 行数の多いコメントの「続きを読む」「閉じる」ボタンの制御
   */
  toggleLongCommentAccordion() {
    const target = window.event.target;
    const comment = target.closest(".is_accordion");
    const commentText = target.parentNode.querySelector(".commentText");
    const commentTextHeight = commentText.scrollHeight;
    comment.classList.toggle("is_active");
    // 吹き出しが開くときのアニメーション用にmax-heightを付け外し
    if (comment.classList.contains("is_active")) {
      const commentTextheightPaddingBottom = Number(
        window.getComputedStyle(commentText).getPropertyValue("padding-bottom").replace(/px/, ""),
      );
      commentText.style.maxHeight = `${commentTextHeight + commentTextheightPaddingBottom}px`;
    } else {
      commentText.style.maxHeight = "";
    }
    // 「すべてのコメントを見る」ボタンでコメントたちが全数表示になっている場合、吹き出しが広がりきらないため、heightをautoで上書きする
    target.closest(".overComment.is_active").style.height = "auto";
  },
  /**
   * コメント数が多いときに「すべてのコメントを見る」ボタンを出して制御
   */
  displayAllCommentsButton() {
    const commentListLi = document.querySelectorAll(".commentList li");
    if (commentListLi.length > this.commentListLiShowLength) {
      document.querySelector(".commentShowAllBtn_box").style.display = "block";
    }
  },
  /**
   * 多いコメントをclassを付けて隠す
   */
  hideOverComment() {
    const commentListLi = document.querySelectorAll(".commentList li");
    commentListLi.forEach((li, index) => {
      if (index < this.commentListLiShowLength) {
        return true;
      }
      li.classList.add("overComment");
    });
  },
  /**
   * コメント欄に入力した時に発火する処理をまとめる
   */
  onClickAllCommentButton() {
    const overComments = document.querySelectorAll(".commentList .overComment");

    // コメントが開くときのアニメーション用にheightを付け外し
    overComments.forEach((overComment) => {
      overComment.classList.toggle("is_active");
      if (overComment.classList.contains("is_active")) {
        const overCommentheight = overComment.scrollHeight;
        overComment.style.height = `${overCommentheight}px`;
      } else {
        overComment.style.height = "";
      }
    });
    // 「すべてのコメントを見る」ボタンを入れ替え
    document.querySelector(".commentShowAllBtn_box").classList.toggle("is_active");
  },
};

/**
 * ページロード後にグローバル定数にCommentFormを追加する
 */
document.addEventListener("DOMContentLoaded", () => {
  Object.defineProperty(globalThis, "Comments", {
    value: Comments,
    writable: false,
  });
  Comments.onLoadedFunctions();
});
